import { FunctionComponent, useMemo, useState } from 'react';

import DaaSTable from '@/components/table/DaasTable';
import { SortDirection, sort } from '@/components/table/sortHelper';
import { MappedCustomerCreditCheck } from '@/services/api/hooks/credit';
import CreditCheckTableRow from './CreditCheckTableRow';
import { EditCreditCheck } from './creditCheckTable.types';

export interface CreditCheckTableData extends MappedCustomerCreditCheck {
  [key: string]: string | number | Date | undefined;
}

export interface CreditCheckTableColumn {
  accessor: string;
  sortable?: boolean;
  text: string;
}

interface CreditCheckTableProps {
  data: CreditCheckTableData[];
  headers: CreditCheckTableColumn[];
  onEdit: EditCreditCheck;
}

const CreditCheckTable: FunctionComponent<CreditCheckTableProps> = ({ data, headers, onEdit }) => {
  const [sortColumnId, setSortColumnId] = useState<string>(headers[0].accessor);
  const [sortDirection, setSortDirection] = useState<SortDirection>(SortDirection.DESC);

  const tableData: CreditCheckTableData[] = useMemo(() => {
    return sort(data, sortColumnId, sortDirection);
  }, [data, sortColumnId, sortDirection]);

  return (
    <DaaSTable
      headers={headers}
      onSortCallback={(columnId, direction) => {
        setSortColumnId(columnId);
        setSortDirection(direction);
      }}
      sortColumnId={sortColumnId}
      sortDirection={sortDirection}
    >
      {tableData.map(row => (
        <CreditCheckTableRow data={row} key={row.id} onEdit={onEdit} />
      ))}
    </DaaSTable>
  );
};

export default CreditCheckTable;
